(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roast-type-spectrum-pdp"] && !Shopify.designMode) return;
  try {
    (function () {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  var DATA_FLAG = "shopByRoastBound";
  var TRIGGER_SELECTOR = "[data-open-shop-by-roast-modal]";
  var BUTTON_SELECTOR =
    "#shop-by-roast-modal-root button, #shop-by-roast-modal-mobile-root button";
  var MAX_ATTEMPTS = 30;
  var OVERLAY_MAX_ATTEMPTS = 40;

  var pickDisplayValue = function (element) {
    if (!element) return "block";

    var className = "";

    try {
      className = element.className || "";
    } catch (error) {
      className = "";
    }

    if (typeof className === "string" && className.length) {
      if (/\binline-flex\b/.test(className)) return "inline-flex";
      if (/\bflex\b/.test(className)) return "flex";
      if (/\binline-grid\b/.test(className)) return "inline-grid";
      if (/\bgrid\b/.test(className)) return "grid";
      if (/\binline-block\b/.test(className)) return "inline-block";
    }

    var tagName = element.tagName;

    if (tagName === "SPAN" || tagName === "A") {
      return "inline-block";
    }

    return "block";
  };

  var forceAncestorsVisible = function (element) {
    if (!element) {
      return function () {};
    }

    var applied = [];
    var current = element;

    while (current && current !== document.body && current !== document.documentElement) {
      var computedStyle = null;

      try {
        computedStyle = window.getComputedStyle(current);
      } catch (error) {
        computedStyle = null;
      }

      if (computedStyle && computedStyle.display === "none") {
        var previousValue = current.style.getPropertyValue("display");
        var previousPriority = current.style.getPropertyPriority("display");

        applied.push({
          element: current,
          value: previousValue,
          priority: previousPriority,
        });

        current.style.setProperty("display", pickDisplayValue(current), "important");
      }

      current = current.parentElement;
    }

    return function () {
      while (applied.length) {
        var item = applied.pop();

        if (!item || !item.element || !item.element.style) continue;

        if (item.value) {
          item.element.style.setProperty("display", item.value, item.priority || "");
        } else {
          item.element.style.removeProperty("display");

          if (!item.element.getAttribute("style")) {
            item.element.removeAttribute("style");
          }
        }
      }
    };
  };

  var findVisibleButton = function () {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var rect = button.getClientRects();

      if (rect && rect.length && rect[0].width > 0 && rect[0].height > 0) {
        return button;
      }
    }

    return buttons.length ? buttons[0] : null;
  };

  var withMenuDrawerClosed = function (trigger, callback) {
    var $ = window.jQuery || window.$;

    if (
      !$ ||
      !$.magnificPopup ||
      !$.magnificPopup.instance ||
      !$.magnificPopup.instance.isOpen
    ) {
      callback();
      return;
    }

    var instance = $.magnificPopup.instance;
    var contentElement = instance.content && instance.content[0];
    var isMenuDrawer = false;

    if (contentElement && contentElement.classList) {
      isMenuDrawer = contentElement.classList.contains("js-menu-draw");
    }

    if (!isMenuDrawer && trigger && typeof trigger.closest === "function") {
      isMenuDrawer = Boolean(trigger.closest(".js-menu-draw"));
    }

    if (!isMenuDrawer) {
      callback();
      return;
    }

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      callback();
    };

    $(document).one("mfpAfterClose.shopByRoast", finish);
    $.magnificPopup.close();

    setTimeout(finish, 400);
  };

  var activationRequestId = 0;

  var pushUnique = function (list, value) {
    if (!value) return;

    if (list.indexOf(value) === -1) {
      list.push(value);
    }
  };

  var buildRoastLevelCandidates = function (value) {
    if (!value && value !== 0) return [];

    var raw = String(value);
    var trimmed = raw.trim();

    if (!trimmed) return [];

    var lower = trimmed.toLowerCase();
    var candidates = [];

    pushUnique(candidates, trimmed);
    pushUnique(candidates, lower);
    pushUnique(candidates, trimmed.replace(/[_\s]+/g, "-"));
    pushUnique(candidates, lower.replace(/[_\s]+/g, "-"));
    pushUnique(candidates, trimmed.replace(/[_\s]+/g, "_"));
    pushUnique(candidates, lower.replace(/[_\s]+/g, "_"));

    var sanitized = lower
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    pushUnique(candidates, sanitized);

    return candidates.filter(Boolean);
  };

  var readRoastLevelInfo = function (trigger) {
    if (!trigger) {
      return { raw: null, candidates: [] };
    }

    var dataset = trigger.dataset || {};
    var raw =
      dataset.roastLevel ||
      dataset.roastlevel ||
      dataset.roast ||
      dataset.roastType ||
      dataset.roasttype ||
      trigger.getAttribute("data-roast-level") ||
      trigger.getAttribute("data-roastlevel") ||
      trigger.getAttribute("data-roast") ||
      trigger.getAttribute("data-roast_type") ||
      trigger.getAttribute("data-roasttype") ||
      null;

    var candidates = buildRoastLevelCandidates(raw);

    return {
      raw: raw,
      candidates: candidates,
    };
  };

  var isElementVisible = function (element) {
    if (!element || typeof element.getClientRects !== "function") {
      return false;
    }

    var rects = element.getClientRects();

    return Boolean(rects && rects.length && rects[0].width > 0 && rects[0].height > 0);
  };

  var findRoastLevelTargets = function (candidates) {
    if (!candidates || !candidates.length) return [];

    var selectors = candidates.reduce(function (list, value) {
      if (!value) return list;

      list.push('#shop-by-roast-modal-root [roastlevel="' + value + '"]');
      list.push('#shop-by-roast-modal-mobile-root [roastlevel="' + value + '"]');

      return list;
    }, []);

    return selectors.reduce(function (found, selector) {
      var elements = document.querySelectorAll(selector);

      if (!elements || !elements.length) {
        return found;
      }

      Array.prototype.forEach.call(elements, function (element) {
        if (found.indexOf(element) === -1) {
          found.push(element);
        }
      });

      return found;
    }, []);
  };

  var activateRoastLevel = function (roastLevelInfo) {
    if (!roastLevelInfo || !roastLevelInfo.candidates.length) return;

    activationRequestId += 1;
    var requestId = activationRequestId;
    var attempt = 0;

    var tryActivate = function () {
      if (requestId !== activationRequestId) return;

      var targets = findRoastLevelTargets(roastLevelInfo.candidates);
      var target = null;

      for (var i = 0; i < targets.length; i += 1) {
        if (isElementVisible(targets[i])) {
          target = targets[i];
          break;
        }
      }

      if (!target && targets.length) {
        target = targets[0];
      }

      if (target) {
        target.click();
        return;
      }

      if (attempt >= MAX_ATTEMPTS) {
        console.warn(
          'Shop by Roast modal: unable to locate roast level "' +
            (roastLevelInfo.raw || roastLevelInfo.candidates[0]) +
            '" to activate.'
        );
        return;
      }

      attempt += 1;
      setTimeout(tryActivate, 100);
    };

    tryActivate();
  };

  var isRoastModalOverlay = function (element) {
    if (!element) return false;

    if (!element.classList || !element.classList.contains("fixed")) {
      return false;
    }

    if (!element.querySelector("[roastlevel]")) {
      return false;
    }

    return true;
  };

  var findRoastModalOverlay = function (root) {
    if (!root) return null;

    var overlays = root.querySelectorAll(".fixed");

    for (var i = 0; i < overlays.length; i += 1) {
      if (isRoastModalOverlay(overlays[i])) {
        return overlays[i];
      }
    }

    return null;
  };

  var monitorModalLifecycle = function (root, releaseVisibility) {
    if (!root || typeof releaseVisibility !== "function") {
      return;
    }

    var released = false;
    var observer = null;

    var finalize = function () {
      if (released) return;
      released = true;

      if (observer) {
        observer.disconnect();
      }

      releaseVisibility();
    };

    var ensureObserver = function () {
      if (observer || !root || typeof MutationObserver === "undefined") {
        return;
      }

      observer = new MutationObserver(function () {
        if (!findRoastModalOverlay(root)) {
          finalize();
        }
      });

      try {
        observer.observe(root, { childList: true, subtree: true });
      } catch (error) {
        observer = null;
      }
    };

    var waitForOverlayAttempts = 0;

    var waitForOverlay = function () {
      if (released) return;

      var overlay = findRoastModalOverlay(root);

      if (overlay) {
        ensureObserver();

        var pollForClose = function () {
          if (released) return;

          if (!findRoastModalOverlay(root)) {
            finalize();
            return;
          }

          setTimeout(pollForClose, 400);
        };

        pollForClose();

        if (overlay && overlay.dataset) {
          overlay.dataset.shopByRoastObserved = "true";
        }

        return;
      }

      if (waitForOverlayAttempts >= OVERLAY_MAX_ATTEMPTS) {
        finalize();
        return;
      }

      waitForOverlayAttempts += 1;
      setTimeout(waitForOverlay, 100);
    };

    waitForOverlay();
  };

  var openModal = function (trigger) {
    var roastLevelInfo = readRoastLevelInfo(trigger);

    withMenuDrawerClosed(trigger, function () {
      var modalButton = findVisibleButton();

      if (modalButton) {
        var modalRoot = null;

        if (typeof modalButton.closest === "function") {
          modalRoot = modalButton.closest(
            "#shop-by-roast-modal-root, #shop-by-roast-modal-mobile-root"
          );
        }

        var releaseVisibility = forceAncestorsVisible(modalRoot);

        modalButton.click();
        activateRoastLevel(roastLevelInfo);
        if (modalRoot) {
          monitorModalLifecycle(modalRoot, releaseVisibility);
        } else {
          releaseVisibility();
        }
        return;
      }

      console.warn(
        "Shop by Roast modal trigger button not found. Ensure the header modal is loaded."
      );
    });
  };

  var bindTriggers = function () {
    var triggers = document.querySelectorAll(TRIGGER_SELECTOR);

    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset[DATA_FLAG]) return;

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        openModal(trigger);
      });

      trigger.dataset[DATA_FLAG] = "true";
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindTriggers, {
      once: true,
    });
  } else {
    bindTriggers();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
